// extracted by mini-css-extract-plugin
module.exports = {"default":"LogoContentWrapper__default__30T6C","content-wrapper":"LogoContentWrapper__content-wrapper__2FERV"};